export const defaultStateCodeForMarket = (marketCode: GQL_MarketCode) => {
  switch (marketCode) {
    case 'NSW':
      return 'NSW'
    case 'VIC':
      return 'VIC'
    case 'NZ':
      return 'North Island'
    case 'WA':
      return 'WA'
    case 'OR':
      return 'OR'
    default:
      return 'all'
  }
}
